<template>
  <div class="list">
    <job-header-simple header_title="我的协议" :backRouter="backRouter"></job-header-simple>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="init"
      :error.sync="error"
      error-text="请求失败，点击重新加载"
    >
      <div class="public_empty_section contract" v-if="contractList.length == 0">您暂时还没有协议</div>
      <div class="item" v-for="item in contractList" :key="item.id">
        <div class="head">{{item.ocompanyName}}</div>
        <div class="subhead">
          <van-tag round type="primary">服务</van-tag>
          {{item.ecompanyName}}
        </div>
        <div
          class="text"
          v-if="item.status != 'unifiedSignSuccess' && item.status != 'unifiedSignFailure' "
        >
          协议日期：{{item.contractBeginDate}}
          <span v-if="item.contractBeginDate!=null">~</span>
          {{item.contractEndDate}}
        </div>
        <div class="text">
          <span v-if="item.bankName!=null && item.bankName=='支付宝'">
            支付宝：({{item.bankAccount}})
          </span>

          <span v-if="item.bankName!=null && item.bankName !='支付宝'">
            银行卡：
            <span class="text-ellipsis">{{item.bankName}}</span>
            ({{item.bankAccount}})
          </span>
        </div>
        <div
          class="status"
          v-if="item.status == 'signed' || item.status == 'unifiedSignSuccess' || item.status == 'unifiedSignFailure'"
        >
          <div class="position">
            <span class="icon_type type_did"></span>
            <van-button
              type="primary"
              size="mini"
              class="btn_min_theme"
              is-link
              :to="{path:'/card?type=1&contractId='+item.id+'&ocompanyId='+item.ocompanyId}"
            >更换</van-button>
          </div>
          <van-button
            type="warning"
            size="large"
            class="btn_max warning"
            v-if="item.status == 'signed'"
            @click="check(item)"
          >查看协议</van-button>
        </div>
        <div class="status" v-if="item.status == 'termination'">
          <div class="position">
            <span class="icon_type type_end"></span>
          </div>
          <van-button type="warning" size="large" class="btn_max warning" @click="check(item)">查看协议</van-button>
        </div>
        <div class="status" v-if="item.status == 'unifiedSignSuccess'">
          <div class="position">
            <span class="icon_type type_end"></span>
          </div>
          <van-button type="warning" size="large" class="btn_max warning" @click="check(item)">查看协议</van-button>
        </div>
        <div class="status" v-if="item.status == 'wsign'">
            <template v-if="item.flowId&&item.flowId.length>0">
                <div class="position">
                    <span class="icon_type type_doing"></span>
                </div>
            </template>
            <template v-else>
                <div class="position">
                    <span class="icon_type type_no"></span>
                </div>
            </template>
            <van-button
                    type="primary"
                    size="large"
                    class="btn_max theme"
                    @click="signContract(item)"
                >发起电签</van-button>
     
        </div>
        <div class="status" v-if="item.status == 'cancelled'">
          <div class="position">
            <span class="icon_type type_lose"></span>
            <!-- <span class="icon_type type_all"></span> -->
          </div>
          <!--<van-button type="primary" size="large" class="btn_max disabled">查看协议</van-button>-->
        </div>
        <div class="status" v-if="item.status == 'unifiedSignSuccess'">
          <div class="position">
            <span class="icon_type type_all"></span>
            <van-button
              type="primary"
              size="mini"
              class="btn_min_theme"
              is-link
              :to="{path:'/card?type=1&contractId='+item.id+'&ocompanyId='+item.ocompanyId}"
            >更换</van-button>
          </div>
        </div>
      </div>
    </van-list>
  </div>
</template>
<script>
import { button, Tag, List,Dialog } from "vant";
import jobHeaderSimple from "@/components/header/header.vue";
import api from "@/api/list";
import {
  getIndividualHeaderKey
} from "@/utils/auth";

export default {
  components: {
    [button.name]: button,
    [Tag.name]: Tag,
    [List.name]: List,
    [Dialog.name]: Dialog,
    jobHeaderSimple,
  },
  data() {
    return {
      contractList: [],
      backRouter: "0",
      type: 0,
      page: {
        current: 0,
        size: 10,
        total: 0,
      },
      error: false,
      loading: false,
      finished: false,
    };
  },
  created() {
    //   this.init();
    if(getIndividualHeaderKey()){ this.type = 1}
  },
  // 回退页面问题
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.backRouter = "/user";
    });
  },
  methods: {
    check(item) {
     
      if(item.hasContractFileLink!==undefined&&!item.hasContractFileLink){
        Dialog.alert({
            title: '温馨提示',
            message: ' 人力公司暂不支持第三方平台查看协议，如需查看协议内容请联系客服！',
            confirmButtonText: '知道了'
            });
            return;
      }
      if (!item.contractFile) {
        api.contractUrl({ id: item.id }).then((res) => {
          if (res.status == "200") {
            //判断是否安卓设备
            // if (
            //   navigator.userAgent.indexOf("Android") > -1 ||
            //   navigator.userAgent.indexOf("Adr") > -1
            // ) {

            // } else {
            //   window.open(process.env.VUE_APP_FILE_PATH + res.data.data);
            // }

            this.$router.push({
              path: "/checkContract",
              query: {
                fileURL: process.env.VUE_APP_FILE_PATH + res.data.data,
              },
            });
          }
        });
      } else {
        // if (
        //   navigator.userAgent.indexOf("Android") > -1 ||
        //   navigator.userAgent.indexOf("Adr") > -1
        // ) {

        // } else {
        //   window.open(process.env.VUE_APP_FILE_PATH + item.contractFile);
        // }
        this.$router.push({
          path: "/checkContract",
          query: {
            fileURL: process.env.VUE_APP_FILE_PATH + item.contractFile,
          },
        });
        // window.open("http://admin.grejob.com/upload" + item.contractFile);
        // window.open("http://183.62.139.165:85/upload" + item.contractFile);
      }
    },
    init() {
      let param = {};
      param.current = this.page.current + 1;
      param.size = this.page.size;
      param.type = this.type;
      api.contractListByActiveUser(param).then((res) => {
        if (res.data.status == "200") {
          this.page.current = res.data.data.current;
          this.page.size = res.data.data.size;
          let records = res.data.data.records;
          this.contractList = this.contractList.concat(records);

          // 加载状态结束
          this.loading = false;
          if (res.data.data.current >= res.data.data.pages) {
            this.finished = true;
          }
        } else {
          this.loading = false;
          this.error = true;
        }
      });
    },
    signContract(obj) {
      this.$router.push({
        path: "/contractBase",
        query: { obj: obj.id },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.list {
  .item {
    position: relative;
    margin: 12px;
    border-radius: 6px;
    background: #fff;
    padding: 10px 15px 15px;
    font-size: 13px;
    line-height: 26px;
    .head {
      color: #333;
    }
    .subhead {
      color: #666;
    }
    .text {
      color: #666;
      span {
        color: #333;

        .text-ellipsis {
          display: inline-block;
          vertical-align: middle;
          margin-top: -2px;
          max-width: 10em;
        }
      }
    }
    .status {
      margin-top: 20px;
      .position {
        position: absolute;
        right: 15px;
        top: 10px;
        width: 52px;
        text-align: center;
      }
      .icon_type {
        display: inline-block;
        width: 51px;
        height: 51px;
        background-position: center center;
        background-size: contain;
        background-repeat: no-repeat;
        &.type_did {
          background-image: url(./assets/type_ok.png);
        }
        &.type_no {
          background-image: url(./assets/type_no.png);
        }
        &.type_doing {
          background-image: url(./assets/type_doing.png);
        }
        &.type_lose {
          background-image: url(./assets/type_ineff.png);
        }
        &.type_end {
          background-image: url(./assets/type_end.png);
        }
        &.type_all {
          background-image: url(./assets/type_all.png);
        }
      }
    }
  }

  .btn_min_warning {
    border-color: #f3a26c;
    background-color: #f3a26c;
  }

  .btn_min_theme {
    margin-left: 0;
    border-color: #6c7ef3;
    background-color: #6c7ef3;
  }

  .btn_max {
    height: 40px;
    line-height: 38px;
    font-size: 14px;

    &.warning {
      border-color: #f3a26c;
      background-color: #f3a26c;
    }

    &.theme {
      border-color: #6c7ef3;
      background-color: #6c7ef3;
    }

    &.disabled {
      border-color: #dadada;
      background-color: #dadada;
    }
  }
}
</style>


